import React from 'react';

import { useThemedStyles } from '../../hooks/useThemedStyles';
import Text from '../../components/text/Text';
import { Card } from '../../design/components';
import useEndOfDaySteps from '../driver/endOfDay/useEndOfDaySteps';
import { createClockPassViewStyles } from './ClockPassView.styles';

// End of day's unfinished-steps warning, shown before a clock-out scan; it never blocks it (decision 10).
const ClockOutStepsWarning = ({ day }) => {
	const styles = useThemedStyles(createClockPassViewStyles);
	const { clockOutWarning } = useEndOfDaySteps(day);

	if (!clockOutWarning) {
		return null;
	}

	return (
		<Card tone="warning">
			<Text style={styles.clockOutWarningText}>{clockOutWarning}</Text>
		</Card>
	);
};

export default ClockOutStepsWarning;
